import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { interval: { type: Number, default: 15_000 } }

  connect() {
    this.startRefreshing()
  }

  disconnect() {
    this.stopRefreshing()
  }

  startRefreshing() {
    this.stopRefreshing() // Ensure no duplicate intervals
    // A turbo-frame with a src already eager-loads on connect, so an immediate
    // reload here would just duplicate that fetch — only refresh now when there's
    // no src to load.
    if (!this.element.hasAttribute("src")) this.refresh()
    this.intervalId = setInterval(() => this.refresh(), this.intervalValue)
  }

  stopRefreshing() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  refresh() {
    this.element?.reload()
  }
}
